import React from 'react';
import post from "../assets/images/schedule.png";
import user from "../assets/images/user.png";
import insta from '../assets/icons/insta.svg';
import { FiCalendar } from "react-icons/fi";
import { FiClipboard } from "react-icons/fi";
import DotMenu from './DotMenu';
import { MdOutlineSyncAlt } from "react-icons/md";
import { PiTrashLight } from "react-icons/pi";
import { CiCalendar } from "react-icons/ci";

const options = [
  { label: 'Post in other account', icon: CiCalendar },
  { label: 'Sync content', icon: MdOutlineSyncAlt },
  { label: 'Delete post', icon: PiTrashLight, color: "red" },
];

const PostedCard = () => {
  return (
    <div className="w-[379px] h-[110px] rounded-xl bg-white flex items-center gap-2">
      <img src={post} className="w-[93px] h-[102px] m-1 inline-block" alt="post" />
      <div className="w-full py-3 pr-3">
        <div className="flex justify-between">
          <p className="text-[#0F0C18] text-base font-medium tracking-tight">Another video</p>
          <DotMenu options={options} type="normal" md />
        </div>
        <div className="flex items-center gap-[6px] mt-[6px]">
        <div className="flex items-center">
            <img src={user} className="w-4 h-4 rounded-full -mr-[5px] z-20" alt="user" />
            <img src={insta} className="w-4 h-4 rounded-full z-30" alt="workspace" />
          </div>
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">@andrew_wack</p>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[7px] mt-[6px]">
            <FiCalendar className="text-sm text-[#0F0C18]" />
            <div className="text-[#9392A2] text-xs font-medium tracking-tight">Posted at</div>
          </div>
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">12:34 / 23 Jul 2024</p>
        </div>  
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[7px] mt-[6px]">
            <FiClipboard className="text-sm text-[#0F0C18]" />
            <div className="text-[#9392A2] text-xs font-medium tracking-tight">Content type</div>
          </div>
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Instagram reels</p>
        </div>
      </div>
    </div>
  );
};

export default PostedCard;